import {
  FETCH_USER_SESSIONCONTEXT_REQUEST,
  SAVE_ACTIVE_TOPHEADER_COMPONENT,
  UPDATE_USER_THEME,
  GET_USER_ORG_NAME_SUGGESTIONS,
  UPDATE_LAYOUT_SETTINGS,
  CHANGE_USER_ORG_TOKEN,
  // GET_MANAGE_PROFILE,
  GET_LEFT_NAVIGATION
} from "./actionConstants";

export const getUserSessionContextInfo = ()=>({
  type: FETCH_USER_SESSIONCONTEXT_REQUEST
})

export const setActiveTopHeader = payload => ({
  type: SAVE_ACTIVE_TOPHEADER_COMPONENT,
  payload
})

export const updateUserTheme = payload => ({
  type: UPDATE_USER_THEME,
  payload
})

export const fetchUserOrgNameSuggestions = payload => ({
  type: GET_USER_ORG_NAME_SUGGESTIONS,
  payload
})

export const fetchLeftNavigation = payload => ({
  type: GET_LEFT_NAVIGATION,
  payload
})

export const updateLayoutSetting = payload => ({
  type: UPDATE_LAYOUT_SETTINGS,
  payload
})

export const switchOrgToken = payload => ({
  type: CHANGE_USER_ORG_TOKEN,
  payload
})
